export default __webpack_public_path__ + "static/media/brain1.5ad38828.glb";